<div class="relative mt-4">
  <div class="absolute inset-0 flex items-center" aria-hidden="true">
    <div class="w-full border-t border-edge"></div>
  </div>
  <div class="relative flex justify-center">
    <button
      (click)="buttonClick.emit()"
      type="button"
      class="inline-flex items-center shadow-sm px-4 py-1.5 border border-edge-strong text-sm leading-5 font-medium rounded-full text-fg-subtle bg-surface hover:bg-surface-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 gap-2"
    >
      <ng-content></ng-content>
      <span>{{ buttonText }}</span>
    </button>
  </div>
</div>
